declare global {
	interface Window {
		gtag: (...args: unknown[]) => void;
		dataLayer: unknown[];
	}
}

export type GtagEvent =
	| "page_view"
	| "search"
	| "company_view"
	| "score_view"
	| "score_teaser_view"
	| "score_teaser_cta_click"
	| "watchlist_limit_reached"
	| "anon_register_cta_click"
	| "login"
	| "sign_up"
	| "begin_checkout"
	| "purchase"
	| "navigation_timing";

export type GtagEventParams = Record<string, string | number | boolean | null | undefined>;

/**
 * Send a GA4 event. Safe to call even if gtag is not loaded or consent is denied.
 */
export function trackEvent(event: GtagEvent, params?: GtagEventParams): void {
	if (typeof window === "undefined" || typeof window.gtag !== "function") return;
	window.gtag("event", event, params);
}

/**
 * Update gtag consent state. Called when user accepts or rejects cookies.
 */
export function updateGtagConsent(analyticsGranted: boolean): void {
	if (typeof window === "undefined" || typeof window.gtag !== "function") return;
	window.gtag("consent", "update", {
		analytics_storage: analyticsGranted ? "granted" : "denied",
		ad_storage: "denied",
		ad_user_data: "denied",
		ad_personalization: "denied",
	});
}
